import { GetHostUrl } from '@/tools/network_tools';

export default class NetworkManager {
  constructor(config) {
    this.hosts = {};
    this.__init(config);
    console.log(this.hosts);
  }

  __init(config) {
    const hosts = {};
    for (const host of config.hosts) {
      let endPoint = host.endPoint;
      if (endPoint === undefined) endPoint = 'akad';
      hosts[host.name] = {
        host: host.host,
        port: host.port,
        domain: host.domain,
        endPoint: endPoint,
      };
    }
    const keys = Object.keys(hosts);
    for (const key of keys) {
      this.hosts[key] = GetHostUrl(key, hosts);
    }
  }

  renderUri() {
    return this.hosts.render;
  }

  uriPath(host, reqType) {
    if (reqType) return `${this.hosts[host]}${reqType}`;
    return `${this.hosts[host]}`;
  }
}
